import { useState } from 'react';
import { getValidityColor } from 'utils/runStatistics';
import { ConsistencyCollectionView } from '../types';

const STATUS_COLORS: Record<string, string> = {
  ERROR: 'var(--cogs-red)',
  IN_PROGRESS: 'var(--cogs-blue)',
};

export const useCollectionCard = (collection: ConsistencyCollectionView) => {
  const [confirmingDelete, setConfirmingDelete] = useState(false);

  const totalValid = collection.lastRun?.totalValid ?? 0;
  const totalFailed = collection.lastRun?.totalFailed ?? 0;
  const total = totalValid + totalFailed;
  const validPercentage =
    total > 0 ? Math.round((totalValid / total) * 100) : 0;

  const validityColor = collection.lastRun
    ? (STATUS_COLORS[collection.lastRun.status] ??
      getValidityColor(validPercentage))
    : 'var(--cogs-greyscale-grey6)';

  return {
    confirmingDelete,
    setConfirmingDelete,
    validPercentage,
    validityColor,
  };
};
